import React from 'react';
import PageDetails from '../templates/Page/Page';
import { graphql, useStaticQuery } from 'gatsby';

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query getNodePageHome {
      nodePage(id: { eq: "f9c446d9-4e82-57b8-bcd8-b451fb88c380" }) {
        title
        relationships {
          field_paragraphs {
            ... on paragraph__dashboard {
              internal {
                type
              }
            }
            ... on paragraph__dashboard_city {
              internal {
                type
              }
            }
            ... on paragraph__downloads {
              internal {
                type
              }
            }
            ... on paragraph__faq {
              internal {
                type
              }
            }
            ... on paragraph__header {
              field_title
              field_description
              internal {
                type
              }
              relationships {
                node__page {
                  path {
                    breadcrumbs {
                      label
                      path
                    }
                  }
                }
              }
            }
            ... on paragraph__header_with_search {
              field_title
              field_description
              internal {
                type
              }
              relationships {
                node__page {
                  path {
                    breadcrumbs {
                      label
                      path
                    }
                  }
                }
              }
            }
            ... on paragraph__highlighted_links {
              field_display_images
              relationships {
                field_links {
                  field_title
                  field_description
                  field_link {
                    title
                    url
                  }
                  relationships {
                    field_media {
                      ...MediaImageFragment
                    }
                  }
                }
              }
              internal {
                type
              }
            }
            ... on paragraph__indicator_overview {
              internal {
                type
              }
            }
            ... on paragraph__latest_news {
              internal {
                type
              }
            }
            ... on paragraph__news {
              internal {
                type
              }
            }
            ... on paragraph__publication_calendar {
              internal {
                type
              }
            }
            ... on paragraph__reports {
              internal {
                type
              }
            }
            ... on paragraph__search {
              field_title
              internal {
                type
              }
            }
            ... on paragraph__search_function {
              internal {
                type
              }
            }
            ... on paragraph__source_request {
              internal {
                type
              }
            }
            ... on paragraph__text {
              internal {
                type
              }
              field_body {
                processed
              }
            }
          }
        }
      }
      configPagesPageSettings {
        relationships {
          field_indicator_page {
            path {
              alias
            }
          }
          field_news_page {
            path {
              alias
            }
          }
          field_fusion_data {
            path {
              alias
            }
          }
          field_dashboard_city {
            path {
              alias
            }
          }
        }
      }
      allNodeNews(sort: { field_date: DESC }) {
        nodes {
          title
          path {
            alias
            breadcrumbs {
              path
              label
            }
          }
          body {
            processed
          }
          field_date
          relationships {
            field_image {
              ...MediaImageFragment
            }
          }
        }
      }
      allCity(
        sort: {name: ASC}
        filter: {data: {ruimte: {isVlaamseGemeente: {eq: 1}, isFusie: {eq: 0}}}}
      ) {
        nodes {
          name
          identifier
          benchmarkReports {
            type
            optionLabel
            label
            report {
              pdf
              word
            }
            report_advanced {
              pdf
              word
            }
          }
          localReport {
            report {
              pdf
              word
            }
          }
          data {
            ruimte {
              id
              idRuimte
              idRuimteBuurgemeenten
              idRuimteGemeenteGrootte
              idRuimteProvincie
              idRuimteRegio
              in13CentrumSteden
              inVlaamseRand
              is13CentrumSteden
              isBrusselsGewest
              isFaciliteitenGemeente
              isFusie
              isGemeente
              isNietFaciliteitenGemeente
              isProvincie
              isRegio
              isFusie
              isVlaamsGewest
              isVlaamseGemeente
              isVlaamseRand
              ruimte
              typeRuimte
            }
          }
        }
      }
      allFileFile {
        nodes {
          drupal_internal__fid
          publicUrl
        }
      }
    }

    fragment MediaImageFragment on media__image {
      field_media_image {
        alt
      }
      relationships {
        field_media_image {
            gatsbyImage(width: 500, formats: [AUTO, WEBP])
        }
      }
    }
  `);

  return (
    <PageDetails
      pageContext={{
        pageData: data.nodePage,
        additionalData: {
          pageSettings: data.configPagesPageSettings,
          latestNews: data.allNodeNews.nodes.slice(0, 3),
          allCities: data.allCity.nodes,
          allFiles: data.allFileFile.nodes,
        },
      }}
      path={'/start'}
    />
  );
};

export default IndexPage;
